import { Module, Mutation, VuexModule } from "vuex-module-decorators";
import { Mutations } from "@/store/enums/StoreEnums";

@Module({ name: "adminUserGlobalState" })
export default class AdminUserGlobalState extends VuexModule {
  isAdminUserActive = false;

  get isAdminUserActiveMode(): boolean {
    return this.isAdminUserActive;
  }

  @Mutation
  [Mutations.SET_ADMIN_STATE_MODE](state: boolean): void {
    this.isAdminUserActive = state;
  }
}
